import { render, staticRenderFns } from "./Deposit.vue?vue&type=template&id=25d4a3fe&scoped=true&"
import script from "./Deposit.vue?vue&type=script&lang=ts&"
export * from "./Deposit.vue?vue&type=script&lang=ts&"
import style0 from "./Deposit.vue?vue&type=style&index=0&id=25d4a3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d4a3fe",
  null
  
)

export default component.exports